import { Component, Vue } from 'vue-property-decorator';

@Component({})
export default class LinkedinCallback extends Vue {
  get params() {
    const params = new URLSearchParams(window.location.search);
    return {
      code: params.get('code'),
      state: params.get('state'),
      error: params.get('error')
    };
  }

  managePopupLinkedinRedirection() {
    const { code, state, error } = this.params;
    if (!window.opener || window.opener.closed) {
      return;
    }
    window.opener.postMessage(
      error
        ? { error }
        : { code, state },
      window.location.origin
    );
    window.close();
  }

  mounted() {
    this.managePopupLinkedinRedirection();
  }
}
